<template>
  <q-table
    class="q-pb-sm text-weight-bold text-primary"
    flat
    bordered
    virtual-scroll
    style="height: 100%; border-color: #1976d2"
    table-header-class="text-grey"
    title-class="text-body1 text-bold"
    :rows-per-page-options="[0]"
    :columns="columns"
    :data="data.data"
    hide-pagination
    row-key="campaign_id"
  >
  </q-table>
</template>

<script>
export default {
  name: 'ListCampaignsAffiliate',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      columns: [
        {
          name: 'campaign_name',
          label: 'Campanha',
          field: 'campaign_name',
          align: 'left',
          sortable: true
        },
        {
          name: 'total_clicks',
          label: 'Quant Cliques',
          field: 'total_clicks',
          align: 'center',
          sortable: true
        },
        {
          name: 'total_conversions',
          label: 'Quant Conversões',
          field: 'total_conversions',
          align: 'center',
          sortable: true
        },
        {
          name: 'total_amount_cost',
          label: 'Comissão',
          field: (row) => parseFloat(row.total_amount_cost),
          align: 'center',
          sortable: true,
          format: (val) => 'R$ ' + parseFloat(val).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
      ]
    };
  },

  methods: {}
};
</script>
